import STARS from "../assets/animations/stars.json";
import HAND from "../assets/animations/demp-hand.json";

export default {
  STARS,
  HAND,
};
